import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { AvatarUserTypeValues } from "@/ui/core/Avatar";
import type { PressableAvatarCardProps } from "@/ui/core/PressableAvatarCard";
import PressableAvatarCard from "@/ui/core/PressableAvatarCard";

const StoryMeta: Meta<PressableAvatarCardProps> = {
  title: "Core/Pressable Avatar Card",
  component: PressableAvatarCard,
  argTypes: {
    userName: { control: "text" },
    userType: {
      control: "select",
      options: Object.values(AvatarUserTypeValues),
    },
  },
  args: {
    userName: faker.person.firstName(),
    userType: faker.helpers.objectValue(AvatarUserTypeValues),
  },
};

type Story = StoryObj<PressableAvatarCardProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
